// Add any constants related to URL fragments here, e.g. for tab navigation. - Atlan
export const Fragment = {
  documentsTab: 'documents',
};
